import React from "react";
import Slider from "react-slick";
import { Box, Button, Container, Grid, Typography, } from '@mui/material';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import axios from 'axios';
import { useState } from "react";
import { API_URL, APP_URL } from "../../Config";
import { useEffect } from "react";

const TrendingCollections = () => {
    const [collection,setcollection]=useState();
   
    const fetchcollection= async()=>{

        return await axios.get(`${API_URL}/indexData.php?type=collection`, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(res => {
            if(res.data){
             setcollection(res.data);
            }
        
          })
    }

    useEffect(()=>{
        fetchcollection();
        
    },[])

    var settings = {
        dots: false,
        arrows: true,
        autoplay: true,
        infinite: collection && collection.length>4 ? true : false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    
                }
            }
        ]

    };

    return ( 
            <Box className="Auctions">
                <Container maxWidth='xl'>
                    <Typography variant="h2" gutterBottom component='div'  color='#000' fontSize='45px' fontWeight='bold'>
                        Trending Collections
                    </Typography>
                    <Slider {...settings}>
                        {collection && collection.map((colname, index) => (  
                            <Box key={index} className="slide-swiper"> 
                                <Box justifyContent='space-between'>
                                    <Link to={`/CollectionDetails/${colname.collection_name}`}>
                                        <img className='banner_right' src={APP_URL+'/'+colname.collection_logo}alt='' width='100%' />
                                    </Link>
                                 </Box>
                                <Box className="card-title">
                                    <Box>
                                        <Link to='/'>
                                            <Typography variant="body" component='div' >
                                               {colname.collection_name}
                                            </Typography>
                                        </Link>
                                    </Box>
                                    <Box className="items_btn">
                                       <Button variant="outlined">{colname.total} items </Button>
                                     </Box>
                                </Box>
                            </Box> 
                        ))}
                    </Slider>
                </Container>
            </Box> 
    )
}

export default TrendingCollections; 